// lib/email.ts
// Uses apiPost from @/lib/api — same pattern as AuthService.
// The jwt_token stored by biometricAuthService.login() is automatically
// attached to every request by the api.ts interceptor.

import { toast } from "sonner";
import { apiPost } from "@/lib/api";

export interface EmailParams {
    to: string;
    subject: string;
    body: string;   // Full HTML built by EmailAction.tsx or registrationEmail.ts
    textBody?: string;   // Optional plain text fallback
    from?: string;
    from_email?: string;
    sender_name?: string;
    from_name?: string;
    reply_to?: string;
}

const EmailService = {
    async sendEmail(params: EmailParams): Promise<{ data: any; error: any }> {
        try {
            const payload: EmailParams = {
                from: "noreply@monitorhealth.ai",
                from_email: "noreply@monitorhealth.ai",
                sender_name: "MonitorHealth AI",
                from_name: "MonitorHealth AI",
                reply_to: "noreply@monitorhealth.ai",
                ...params,
            };
            const data = await apiPost("/rds/email/send", payload);
            return { data, error: null };
        } catch (error) {
            console.error("❌ Email sending failed:", error);
            toast.error("Failed to send email", {
                description: error instanceof Error ? error.message : "Unknown error",
                duration: 5000,
            });
            return { data: null, error };
        }
    },
};

export default EmailService;